<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="_1-CN ParaOverride-1" id="_idParaDest-2" xml:lang="en-GB"><span class="leading-139-5 CharOverride-1">A</span><span class="CharOverride-1">lso </span><span class="CharOverride-1">by</span><span class="CharOverride-1"> Mark Billingham</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2">The DI Tom Thorne series</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">Sleepyhead</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">Scaredy</span><span class="CharOverride-3"> Cat</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">Lazybones</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">The Burning Girl</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">Lifeless</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">Buried</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">Death Message</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">Bloodline</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">From the Dead</span></p>
<p class="AdCardTitles"><span class="CharOverride-4">The Demands </span><span class="CharOverride-5">(</span><span class="CharOverride-6">published as </span><span class="CharOverride-5">Good as Dead</span></p>
<p class="AdCardTitles"><span class="CharOverride-6">in the United Kingdom</span><span class="CharOverride-5">)</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">The Dying </span><span class="CharOverride-3">Hours</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">The Bones </span><span class="CharOverride-3">Beneath</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">Time of Death</span></p>
<p class="Basic-Paragraph ParaOverride-4"><span class="CharOverride-2">Other fiction</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">In the Dark</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">Die of Shame</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">Rush of Blood</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBookVR02451.vue?658d4701